<template>
  <div class="global-layout layout-empty" :class="{ [`route-${$route.name}`]: $route.name }" data-test-layout-empty>
    <div ref="layoutContent" class="layout-content" role="main">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .layout-empty {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .layout-content {
    width: 100%;
    min-height: 100vh;
  }
</style>
